import Swal, { SweetAlertIcon } from "sweetalert2"


export const loadingModal = (title?:string, text?:string) => {
  // abrir modal cargando...
  Swal.fire({
    title: title ? title : '',
    text: text ? text : 'Please wait while your changes are being saved',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
}

export const modalWithHtml = (title:string, html:string|HTMLElement, icon:SweetAlertIcon) => {
  Swal.fire({
    title: title,
    icon: icon,
    html: html,
    confirmButtonText: 'OK'
  });
}

export const modalSuccess = (title:string, text:string) => {
  // abrir modal success
  Swal.fire({
    title: title,
    text: text,
    icon: 'success'
  });
}

export const modalError = (title:string, text?:string, html?: string) => {
  // abrir modal error
  Swal.fire({
    title: title,
    icon: 'error',
    // 👇 prioridad: html > text
    ...(html
      ? { html: html }
      : { text: text })
  });
}

export const modalWarning = (title:string, text:string) => {
  // abrir modal warning
  Swal.fire({
    title: title,
    text: text,
    icon: 'warning'
  });
}

export const modalInfo = (title:string, text:string) => {
  // abrir modal info
  Swal.fire({
    title: title,
    text: text,
    icon: 'info'
  });
}

export const modalClose = () => {
  Swal.close();
}

export const modalSuccessDismiss = (title:string, text?:string, html?: string, onClose?: () => void) => {
  // abrir modal error
  Swal.fire({
    title: title,
    icon: 'success',
    timer: 2000,
    timerProgressBar: true,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    // 👇 prioridad: html > text
    ...(html
      ? { html: html }
      : { text: text })
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.timer) {
      onClose?.(); // 👈 se ejecuta SOLO al cerrarse
    }
  });
}